import styled from "styled-components";
import { device } from "./Device";
import abstract2 from "../asset/pictures/abstract2.png";

const ShowMore = styled.div`
  background: url(${(props) => props.backgroundImg}) no-repeat;
  display: flex;
  }
`;
const ShowMoreSkills = styled(ShowMore)`
  @media ${device.tablet} {
    background-size: contain;
    background-position: 4%;
    justify-content: center;
  }
`;
const ShowMoreColumn = styled(ShowMore)`
  @media ${device.mobileL} {
    flex-direction: column;
    margin: 14px;
  }
`;

const ShowMoreParcours = styled(ShowMore)`
  justify-content: flex-end;
  background-position: 1% 100%;
  background-size: 30%;

  & video {
    max-width: 65%;
  }

  @media ${device.tablet} {
    height: 37vh;
  }
`;
const ContainerMorePortfolio = styled.div`
  display: flex;
  justify-content: center;
  background: url(${abstract2});

  img {
    width: 250px;
    height: 454px;
  }
`;
export {
  ShowMore,
  ShowMoreColumn,
  ShowMoreParcours,
  ContainerMorePortfolio,
  ShowMoreSkills,
};
